import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { FirstcitizensComponent } from './pages/firstcitizens/firstcitizens.component';
import { NcbComponent } from './pages/ncb/ncb.component';
import { MyrewardsComponent } from './pages/myrewards/myrewards.component';
import { LifemilesComponent } from './pages/lifemiles/lifemiles.component';
import { ScotiaComponent } from './pages/scotia/scotia.component';
import { CredomaticComponent } from './pages/credomatic/credomatic.component';
import { LifemilesParthersComponent } from './pages/lifemiles-parthers/lifemiles-parthers.component';
import { CibcComponent } from './pages/cibc/cibc.component';
import { ApapComponent } from './pages/apap/apap.component';
import { CareComponent } from './pages/care/care.component';
import { CryptmiComponent } from './pages/cryptmi/cryptmi.component';

import { SubdomainGuard } from './guards/subdomain.guard';
import { LanguajeGuard } from './guards/languaje.guard';
import { MilesBlueComponent } from './pages/miles-blue/miles-blue.component';
import { MilesComponent } from './pages/miles/miles.component';
import { ChnComponent } from './pages/chn/chn.component';
import { GenniusComponent } from './pages/gennius/gennius.component';
import { CuscatlanComponent } from './pages/cuscatlan/cuscatlan.component';
import { ImagineComponent } from './pages/imagine/imagine.component';
import { OneComponent } from './pages/one/one.component';

const appRoutes: Routes = [
  { path: 'firstcitizens', component: FirstcitizensComponent, canActivate: [LanguajeGuard] },
  { path: 'ncb', component: NcbComponent, canActivate: [LanguajeGuard] },
  { path: 'myrewards', component: MyrewardsComponent, canActivate: [LanguajeGuard] },
  { path: 'lifemiles', component: LifemilesComponent, canActivate: [LanguajeGuard] },
  { path: 'scotia', component: ScotiaComponent, canActivate: [LanguajeGuard] },
  { path: 'bac', component: CredomaticComponent, canActivate: [LanguajeGuard] },
  { path: 'lifemiles-more-fare', component: LifemilesParthersComponent, canActivate: [LanguajeGuard] },
  { path: 'cibc', component: CibcComponent, canActivate: [LanguajeGuard] },
  { path: 'apap', component: ApapComponent, canActivate: [LanguajeGuard] },
  { path: 'popular', component: CareComponent, canActivate: [LanguajeGuard] },
  { path: 'miles-blue', component: MilesBlueComponent, canActivate: [LanguajeGuard] },
  { path: 'cryptmi', component: CryptmiComponent, canActivate: [LanguajeGuard] },
  { path: 'milescare', component: LifemilesComponent, canActivate: [LanguajeGuard] },
  { path: 'miles', component: MilesComponent, canActivate: [LanguajeGuard] },
  { path: 'puntos-CHN', component: ChnComponent, canActivate: [LanguajeGuard] },
  { path: 'gennius', component: GenniusComponent, canActivate: [LanguajeGuard] },
  { path: 'MultiPuntos', component: CuscatlanComponent, canActivate: [LanguajeGuard] },
  { path: 'imagine', component: ImagineComponent, canActivate: [LanguajeGuard] },
  { path: 'one', component: OneComponent, canActivate: [LanguajeGuard] },
  {
    path: 'home', component: HomeComponent,
    canActivate: [SubdomainGuard]
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      useHash: true,
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules,
      enableTracing: true
    })
  ],
  exports: [RouterModule]
})


export class AppRoutingModule { }